import { csColorBackground } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { css, type CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'

export const variantMatrixStyle: CSSResult = css`
  :host {
    display: block;
    --csc-variant-matrix-default-product-column-width: 285px;
  }

  .variant-matrix {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
  }

  .variant-matrix__heading {
    margin: 0;
  }

  .variant-matrix__content {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    width: 100%;
  }

  .variant-matrix__toolbar {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing05};
    flex: none;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0;
    overflow: visible;
    min-width: 0;
  }

  .variant-matrix__active-filters-container {
    width: 100%;
    padding: ${csSpacing.spacing06};
  }

  .variant-matrix__toolbar-filter-wrap {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    overflow: visible;
    flex: 0 0 auto;
  }

  .variant-matrix__toolbar-filter,
  .variant-matrix__toolbar-columns {
    flex-shrink: 0;
  }

  .variant-matrix__toolbar-filter {
    flex: none;
  }

  .variant-matrix__toolbar-columns {
    flex: 0 0 auto;
  }

  .variant-matrix__toolbar-filter-badge {
    --cse-badge-floating-border-width: 0;
    position: absolute;
    top: -6px;
    right: -6px;
    pointer-events: none;
  }

  .variant-matrix__sort {
    min-width: 0;
    flex: 1 1 auto;
    max-width: max-content;
  }

  .variant-matrix__sort cse-chip {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .variant-matrix__active-filters {
    --cse-paper-secondary-background-color: ${csColorBackground.primary};
    --cse-paper-padding-x: ${csSpacing.spacing06};
    --cse-paper-padding-y: ${csSpacing.spacing05};
  }

  .variant-matrix__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${csSpacing.spacing05};
  }

  .variant-matrix__panel-wrapper {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
  }

  .variant-matrix__panel {
    display: flex;
    flex-direction: column;
    width: 100%;
    border: ${csBorder.width} solid ${csColorBorder.light};
  }

  .variant-matrix__panel--empty {
    display: none;
  }

  .variant-matrix__table {
    display: none;
    width: 100%;
    overflow-x: auto;
  }

  .variant-matrix__table csc-table {
    border: none !important;
    min-width: min-content;
    --csc-table-cell-padding-x: ${csSpacing.spacing06};
  }

  .variant-matrix__mobile-list {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    padding: 0;
  }

  .variant-matrix__mobile-card {
    --cse-paper-row-gap: ${csSpacing.spacing06};
  }

  .variant-matrix__mobile-card-header {
    display: flex;
    gap: ${csSpacing.spacing05};
    align-items: flex-start;
  }

  .variant-matrix__mobile-card-info {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
    min-width: 0;
  }

  .variant-matrix__mobile-card-attributes {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .variant-matrix__mobile-attribute {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: ${csSpacing.spacing06};
    align-items: start;
  }

  .variant-matrix__mobile-attribute-label {
    text-transform: uppercase;
  }

  .variant-matrix__mobile-attribute-value {
    text-align: right;
  }

  .variant-matrix__mobile-price {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: ${csSpacing.spacing04};
  }

  .variant-matrix__mobile-order-actions {
    display: flex;
    align-items: flex-start;
    gap: ${csSpacing.spacing05};
  }

  .variant-matrix__mobile-order-form {
    flex: 1 1 auto;
    min-width: 0;
  }

  @media (min-width: ${SCREENS.small}) {
    :host {
      --csc-variant-matrix-default-product-column-width: 200px;
    }

    .variant-matrix__toolbar {
      flex: 1 0 0;
      flex-wrap: nowrap;
      justify-content: flex-end;
      padding: ${csSpacing.spacing05} ${csSpacing.spacing06};
      border: ${csBorder.width} solid ${csColorBorder.light};
    }

    .variant-matrix__active-filters-container {
      padding: ${csSpacing.spacing05} ${csSpacing.spacing06};
      border-bottom: ${csBorder.width} solid ${csColorBorder.light};
    }

    .variant-matrix__panel-wrapper {
      gap: 0;
    }

    .variant-matrix__panel {
      border-top: none;
    }

    .variant-matrix__panel--empty {
      display: flex;
    }

    .variant-matrix__table {
      display: block;
    }

    .variant-matrix__mobile-list {
      display: none;
      padding: ${csSpacing.spacing06};
    }
  }

  @media (min-width: ${SCREENS.medium}) {
    :host {
      --csc-variant-matrix-default-product-column-width: 285px;
    }

    .variant-matrix__active-filters-container {
      padding: 0;
    }
  }
`
